import NextLink from 'next/link';
import { ComponentProps } from 'react';

import classnames from 'classnames';

import Icon, { IconProps } from '../Icon';

import styles from './index.module.scss';

type LinkProps = ComponentProps<'a'> & { external?: boolean; icon?: IconProps['icon'] | null };

export function Link({ children, className, external, icon, href = '#', onClick, ...props }: LinkProps) {
  let linkIcon = icon;

  if (external && typeof icon === 'undefined') {
    linkIcon = 'arrow-up-right-from-square';
  }

  return (
    <a
      className={classnames(styles.link, className)}
      data-component="link"
      href={href}
      rel={external ? 'noreferrer' : undefined}
      target={external ? '_blank' : '_self'}
      onClick={(e) => {
        if (href === '#') {
          e.preventDefault();
        }

        onClick?.(e);
      }}
      {...props}
    >
      {children}
      {linkIcon && <Icon icon={linkIcon} size="xs" />}
    </a>
  );
}

type CustomNextLinkProps = ComponentProps<typeof NextLink> & {
  icon?: IconProps['icon'];
  iconPosition?: 'left' | 'right';
};

export function CustomNextLink({ children, className, icon, iconPosition = 'right', prefetch = false, ...props }: CustomNextLinkProps) {
  const iconElement = icon && <Icon icon={icon} />;

  return (
    <NextLink {...props} className={classnames(styles.link, className)} data-component="link" prefetch={prefetch}>
      {iconPosition === 'left' && iconElement}
      {children}
      {iconPosition === 'right' && iconElement}
    </NextLink>
  );
}
